import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appNumericRangeByTypeValidate][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: NumericRangeByTypeValidateDirective, multi: true }
  ]
})
export class NumericRangeByTypeValidateDirective implements Validator {
  @Input('appNumericRangeByTypeValidate') type: string;

  private readonly numRange: { [key: string]: minmax } =
    {
      'byte': { 'min': 0n, 'max': 255n },
      'short': { 'min': -32768n, 'max': 32767n },
      'int': { 'min': -2147483648n, 'max': 2147483647n },
      'long': { 'min': -9223372036854775808n, 'max': 9223372036854775807n },
    };

  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value == null || !Object.keys(this.numRange).includes(this.type))
      return null;

    let value: bigint;
    try {
      value = BigInt(control.value);
    }
    catch {
      return null;
    }

    const validationKey = 'numericRange';
    const min: bigint = this.numRange[this.type].min;
    const max: bigint = this.numRange[this.type].max;
    const isValid: boolean = value >= min && value <= max;

    if (!isValid) {
      return { [validationKey]: true };
    }

    return null;
  }
}

interface minmax {
  min: bigint;
  max: bigint;
}